var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeChildrenLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 24,
    viewBox: "0 0 48.5 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41522",
    "data-name": "Group 41522",
    transform: "translate(-746 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15750",
    "data-name": "Rectangle 15750",
    width: 48,
    height: 24,
    transform: "translate(746)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41515",
    "data-name": "Group 41515",
    transform: "translate(758)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2844",
    "data-name": "Line 2844",
    x1: 36,
    transform: "translate(0 12)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2845",
    "data-name": "Line 2845",
    y1: 12,
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeChildrenLarge);
export default __webpack_public_path__ + "static/media/tree-children-large.e572f0f9b28e171bf7dc99bf1b14d576.svg";
export { ForwardRef as ReactComponent };